import Vue from 'vue'

// vue组件引入
const vueFile = require.context('@/components', true, /\.vue$/)
const install = () => {
  vueFile.keys().forEach((key) => {
    const component = vueFile(key).default
    Vue.component(component.name, component)
  })
}
install()
// js组件引入
const jsFile = require.context('@/components', true, /\.js$/)
const installJs = () => {
  jsFile.keys().filter(i => i !== './index.js').forEach((key) => {
    const component = jsFile(key).default
    Vue.component(component.name, component)
  })
}
installJs()

// svg组件引入
const requireAll = requireContext => requireContext.keys().map(requireContext)
const installSvg = () => {
  const req = require.context('@/assets/svg', false, /\.svg$/)
  requireAll(req)
}
installSvg()



// WEBPACK FOOTER //
// ./src/components/index.js